import { FunctionComponent, useState, useEffect } from 'react';
import ActivityMultiSelectItem from './ActivityMultiSelectItem/ActivityMultiSelectItem';
import styles from './ActivityMultiSelect.module.scss';

export type MultiSelectProps = {
  items: {
    label: string;
    active: boolean;
    color?: string;
    onClick?: () => void;
  }[];
};

type FC = FunctionComponent<MultiSelectProps>;

const MultiSelect: FC = ({ items }: MultiSelectProps) => {
  const [itemState, setItemsState] = useState(items);

  useEffect(() => {
    setItemsState(items);
  }, [items]);

  const handleClick = (idx: number, cb?: () => void) => {
    const CurrentItemState = [...itemState];
    CurrentItemState[idx].active = !itemState[idx].active;
    setItemsState(CurrentItemState);
    cb?.();
  };

  return (
    <div className={styles.container}>
      <div className={styles.MultiSelectItems}>
        {itemState.map(({ label, active, color, onClick }, idx) => (
          <ActivityMultiSelectItem
            key={`MultiSelect-${label}`}
            idx={idx}
            label={label}
            isActive={active}
            color={color}
            onClick={(id) => handleClick(id, onClick)}
          />
        ))}
      </div>
    </div>
  );
};

export default MultiSelect;
